/* global KEY_CODES */

(function ($, M, KEY_CODES) {
  'use strict';

  // Multimedia levels (variable rendered in html)
  M.renderer.ready(function () {
    if (typeof window.level_multimedia !== 'undefined') {
      var html = MEMRISE.renderer.rich_format(window.level_multimedia);
      $('.multimedia-wrapper').html(html);
      MEMRISE.renderer.do_embeds($('.multimedia-wrapper'));
    }

    $('[data-placement]').tooltip();
  });

  $(document).on('click', '[data-role="level-restart"]', function () {
    var level_id = $(this).dataAttr('level-id');

    M.modal.yes_no(
      _t('Restart?'),
      _t(
        'This will __s1__wipe your learning history for this level__s2__. __br__You will start from the beginning again. __br__Are you sure?',
        { s1: '<strong>', s2: '</strong>', br: '<br /><br />' },
      ),
      function () {
        M.modal.spinner_open(
          _t('Restarting'),
          _t('Wiping your learning history...'),
        );
        level_restart(level_id);
      },
    );
    return false;
  });

  function level_restart(level_id) {
    $.ajax({
      url: '/ajax/level/restart/',
      type: 'POST',
      data: {
        level_id: level_id,
      },
      success: function (response) {
        if (response.success) {
          window.location.reload();
        }
      },
    });
  }

  const level_ignore = ignore => {
    const ignoreData = [];
    const courseId = parseInt($('body').dataAttr('course-id'), 10);
    $('.thing.text-text').each(function () {
      ignoreData.push({
        learnable_id: parseInt($(this).dataAttr('learnable-id'), 10),
        ignored: ignore,
        course_id: courseId,
      });
    });

    $.ajax({
      url: '/ajax/ignore_learnables/',
      type: 'POST',
      data: {
        ignore_data: JSON.stringify(ignoreData),
      },
      success: () => {
        window.location.reload();
      },
    });
  };

  // Auto-learn
  $('[data-role="auto-learn"]').on('click', function () {
    var level_id = $(this).dataAttr('level-id');
    M.modal.spinner_open('Learning..');
    $.ajax({
      url: '/ajax/auto_learn/',
      type: 'POST',
      data: {
        level_id: level_id,
      },
      success: function (response) {
        window.location.reload();
      },
    });
  });

  // Ignore UI form.

  $(document).on('click', '.ignore-show', function () {
    $('.things-header, .thinguser, .practise').hide();
    $('.ignore-ui').slideDown();
    return false;
  });

  $(document).on('click', '.ignore-all', function () {
    $('.ignore-ui input[type=checkbox]').prop('checked', true);
    return false;
  });

  $(document).on('click', '.ignore-none', function () {
    $('.ignore-ui input[type=checkbox]').prop('checked', false);
    return false;
  });

  $(document).on('click', '.ignore-save', function () {
    const ignoreData = [];
    const courseId = parseInt($('body').dataAttr('course-id'), 10);
    $('.ignore-ui input[type=checkbox]').each(function () {
      ignoreData.push({
        learnable_id: parseInt($(this).dataAttr('learnable-id'), 10),
        ignored: $(this).prop('checked'),
        course_id: courseId,
      });
    });

    $.ajax({
      url: '/ajax/ignore_learnables/',
      type: 'POST',
      data: {
        ignore_data: JSON.stringify(ignoreData),
      },
      success: () => {
        var loc = window.location;
        window.location = loc;
      },
    });
  });

  $(document).on('click', '.ignore-grammar-save', () => {
    level_ignore(true);
  });

  $(document).on('click', '.unignore-grammar-save', () => {
    level_ignore(false);
  });

  // Enter to hit the button
  $(document).on('keydown', function (event) {
    if (event.which === KEY_CODES.ENTER && $('*:focus').length === 0) {
      var $go = $('#go-button');
      if ($go.length > 0) {
        window.location = $go.attr('href');
      }
    }
  });
})(jQuery, MEMRISE, KEY_CODES);
